// import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { debounce } from 'lodash';
// material
import { styled, useTheme } from '@mui/material/styles';
import {
  Toolbar,
  OutlinedInput,
  InputAdornment,
  MenuItem,
  InputLabel,
  FormControl,
  Select,
} from '@mui/material';
// component
import Iconify from '../../components/Iconify';

// ----------------------------------------------------------------------

const RootStyle = styled(Toolbar)(({ theme }) => ({
  height: 96,
  display: 'flex',
  justifyContent: 'start',
  gap: '1rem',
  padding: theme.spacing(0, 1, 0, 3),
}));

const SearchStyle = styled(OutlinedInput)(({ theme }) => ({
  width: '100%',
  transition: theme.transitions.create(['box-shadow', 'width'], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter,
  }),
  '&.Mui-focused': { boxShadow: theme.customShadows.z8 },
  '& .MuiOutlinedInput-notchedOutline': {
    borderWidth: `1px !important`,
    borderColor: `${theme.palette.grey[500_32]} !important`,
  },
}));

// ----------------------------------------------------------------------

// ListHead.propTypes = {
//   numSelected: PropTypes.number,
//   filterName: PropTypes.string,
//   onFilterName: PropTypes.func,
// };

export default function ListToolbar({
  field,
  setSearchField,
  setSearchInput,
  selection,
  setSearchRegistered,
  searchRegistered,
}) {
  const { t } = useTranslation();
  const theme = useTheme();
  const conditions = ['all', 'registered', 'unregistered'];
  const handleInput = (event) => {
    setSearchInput(event.target.value);
  };
  const handleRegistered = (event) => {
    setSearchRegistered(event.target.checked);
  };
  const handleUnregistered = (event) => {
    setSearchRegistered(!event.target.checked);
  };
  return (
    <RootStyle
    // sx={{
    //   ...({
    //     color: 'primary.main',
    //     bgcolor: 'grey.200',
    //   }),
    // }}
    >
      <FormControl
        sx={{
          width: 250,
          transition: theme.transitions.create(['box-shadow', 'width'], {
            easing: theme.transitions.easing.easeInOut,
            duration: theme.transitions.duration.shorter,
          }),
          '& .MuiOutlinedInput-notchedOutline': {
            borderWidth: `1px !important`,
            borderColor: `${theme.palette.grey[500_32]} !important`,
          },
        }}>
        <InputLabel
          sx={{
            '&.Mui-focused': { color: theme.palette.grey[600] },
          }}>
          {t('people.search_field')}
        </InputLabel>
        <Select
          sx={{ '&.Mui-focused': { boxShadow: theme.customShadows.z8 } }}
          labelId="field select"
          label={t('people.search_field')}
          value={field}
          onChange={(event) => {
            setSearchField(event.target.value);
          }}>
          {selection.map((select, index) => (
            <MenuItem key={index} value={select.id}>
              {select.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {setSearchRegistered ? (
        <FormControl
          sx={{
            width: 220,
            transition: theme.transitions.create(['box-shadow', 'width'], {
              easing: theme.transitions.easing.easeInOut,
              duration: theme.transitions.duration.shorter,
            }),
            '& .MuiOutlinedInput-notchedOutline': {
              borderWidth: `1px !important`,
              borderColor: `${theme.palette.grey[500_32]} !important`,
            },
          }}>
          <InputLabel
            sx={{
              '&.Mui-focused': { color: theme.palette.grey[600] },
            }}>
            {t('common.registered')}
          </InputLabel>
          <Select
            sx={{ '&.Mui-focused': { boxShadow: theme.customShadows.z8 } }}
            labelId="field select"
            label={t('common.registered')}
            value={searchRegistered}
            onChange={(event) => {
              setSearchRegistered(event.target.value);
            }}>
            {conditions.map((condition, index) => (
              <MenuItem key={index} value={condition}>
                {t(`common.${condition}`)}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      ) : (
        <></>
      )}
      <SearchStyle
        // value={searchInput}
        onChange={debounce(handleInput, 1000)}
        placeholder={`${t('common.search')} ${t(`common.${field.toLowerCase()}`)}`}
        startAdornment={
          <InputAdornment position="start">
            <Iconify icon="eva:search-fill" sx={{ color: 'text.disabled', width: 20, height: 20 }} />
          </InputAdornment>
        }
      />

      {/* )} */}

      {/* {numSelected > 0 ? (
        <Tooltip title="Delete">
          <IconButton>
            <Iconify icon="eva:trash-2-fill" />
          </IconButton>
        </Tooltip>
      ) : (
        <Tooltip title="Filter list">
          <IconButton>
            <Iconify icon="ic:round-filter-list" />
          </IconButton>
        </Tooltip>
      )} */}
    </RootStyle>
  );
}
